<template>
  <div>
    <vue-headful title="Algemene voorwaarden" />
    <Header page_title="Algemene voorwaarden" />
    <div class="px-4 mx-2 pb-4">
      <div class="container-fluid px-0 pb-1 mb-2">
        <div class="text-14 pr-2" v-if="cms" v-html="cms.content">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      cms: null
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.cms = await this.getAPIList("cms/terms_condition_global");
    }
  }
};
</script>

<style scoped>
li {
  position: relative;
  margin-bottom: 20px;
}
ul.list-unstyled.page li {
  position: relative;
  margin-bottom: 5px;
  padding-right: 15px;
}
ul.list-unstyled.page li:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 0;
  top: 13px;
  display: block;
  border-bottom: 2px dotted rgba(98, 90, 85, 0.25);
}
ul.list-unstyled.page li span:first-child {
  background: white;
  position: relative;
  z-index: 1;
  padding-right: 10px;
}
ul.list-unstyled.page span.position-absolute {
  background: white;
  right: 0;
  top: 0;
  z-index: 1;
  padding-left: 5px;
}
</style>
